import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarCloudSettings" */ './lazyIndex')
);

export const lazySaveCalendarCloudSettings = new LazyAction(
    lazyModule,
    m => m.saveCalendarCloudSettings
);

export const lazyInitCalendarCloudSettings = new LazyAction(
    lazyModule,
    m => m.initCalendarCloudSettings
);

export { default as getShouldEventsEndEarlyCloudSetting } from './selectors/getShouldEventsEndEarlyCloudSetting';
export { default as getShortenEventScopeCloudSetting } from './selectors/getShortenEventScopeCloudSetting';
export { default as getEndShortEventsByCloudSetting } from './selectors/getEndShortEventsByCloudSetting';
export { default as getEndLongEventsByCloudSetting } from './selectors/getEndLongEventsByCloudSetting';
export { default as getEnableOnlineMeetingsByDefaultCloudSetting } from './selectors/getEnableOnlineMeetingsByDefaultCloudSetting';
export { default as getDefaultShouldEventsEndEarly } from './utils/getDefaultShouldEventsEndEarly';
export { default as getDefaultShouldShortenEventDuration } from './utils/getDefaultShouldShortenEventDuration';
export { default as getDefaultShouldShortenEventDurationEndEarly } from './utils/getDefaultShouldShortenEventDurationEndEarly';
export { default as getDefaultShouldShortenEventDurationStartLate } from './utils/getDefaultShouldShortenEventDurationStartLate';
export { default as getDefaultEndShortEventsBy } from './utils/getDefaultEndShortEventsBy';
export { default as getDefaultEndLongEventsBy } from './utils/getDefaultEndLongEventsBy';
export { default as getDefaultOnlineMeetingsEnabled } from './utils/getDefaultOnlineMeetingsEnabled';
export { ShortenEventScopeType } from './shortenEventScopeTypeConstants';
